import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { X, Check } from "lucide-react";

export default function CategorySelect({ value, onChange, testId, label = "Categories" }) {
  const [cats, setCats] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    api.get("/categories").then(r => setCats(r.data)).catch(() => {
      toast.error("Failed to load categories");
    });
  }, []);
  const selected = Array.isArray(value) ? value : (value || "").split(",").map(s => s.trim()).filter(Boolean);
  const toggle = (slug) => {
    const next = selected.includes(slug) ? selected.filter(s => s !== slug) : [...selected, slug];
    onChange(next);
  };
  const remove = (slug) => onChange(selected.filter(s => s !== slug));

  return (
    <div className="space-y-2" data-testid={testId || "category-select"}>
      <div className="text-xs text-slate-600 overline">{label}</div>
      <div className="flex flex-wrap items-center gap-1.5 p-2.5 rounded-xl border border-slate-200 bg-white min-h-[46px]">
        {selected.length === 0 && <span className="text-xs text-slate-400 px-1">No categories selected — click below to add</span>}
        {selected.map(s => {
          const c = cats.find(x => x.slug === s);
          return (
            <span key={s} className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full tag-blue overline text-[10px]" data-testid={`cat-chip-${s}`}>
              {c?.name || s}
              <button type="button" onClick={() => remove(s)} className="hover:text-red-700"><X className="w-3 h-3"/></button>
            </span>
          );
        })}
      </div>
      <button type="button" onClick={() => setOpen(!open)} className="text-xs text-sky-700 font-semibold" data-testid={`${testId || "cat"}-toggle`}>
        {open ? "Close picker" : "＋ Pick categories"}
      </button>
      {open && (
        <div className="p-3 rounded-xl border border-slate-200 bg-slate-50 flex flex-wrap gap-1.5 max-h-64 overflow-y-auto" data-testid="category-picker">
          {cats.map(c => {
            const isOn = selected.includes(c.slug);
            return (
              <button key={c.slug} type="button" onClick={() => toggle(c.slug)}
                className={`inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-semibold transition-colors ${isOn ? "bg-sky-700 text-white" : "bg-white text-slate-700 hover:bg-sky-50 border border-slate-200"}`}
                data-testid={`cat-option-${c.slug}`}>
                {isOn && <Check className="w-3 h-3"/>}{c.name}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
